export default __webpack_public_path__ + "static/media/logout.509a52fc.svg";